import { register } from "async-ops";
import { callMdaeApi } from "../../../call-web-api";
export const GET_EHR_DOCUMENTS = "GET_EHR_DOCUMENTS";


export const service = async (data) => {
  const queryString = new URLSearchParams(data).toString();
  const options = {
    url: `/api/v1/documents/ehr-search${queryString ? `?${queryString}` : ""}`,
    type: "GET"
  };
  const response = await callMdaeApi(options);
  return response;
};



const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EHR_DOCUMENTS, service, mock);
